export const CALLBACK_TIMEOUT = 200

export const handleTyping = (callback: (isTyping: boolean) => unknown) => {
  let timeout: number
  let isTyping = false

  return () => {
    if (timeout) {
      window.clearTimeout(timeout)
    }
    if (!isTyping) {
      isTyping = true
      callback(isTyping)
    }

    timeout = window.setTimeout(() => {
      isTyping = false
      callback(isTyping)
    }, CALLBACK_TIMEOUT)
  }
}
